import {Pipe, PipeTransform} from '@angular/core';
import {formatarCnpj, normalizarCnpj} from '../../utils/cnpj.util';

@Pipe({name: 'cpfCnpj'})
export class CpfCnpjPipe implements PipeTransform {

  transform(value: string): string|null {
    if (!value) {
      return null;
    }
    const identificacao = normalizarCnpj(value);

    if (identificacao.length === 11) {
      return identificacao.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
    } else if (identificacao.length === 14) {
      return formatarCnpj(identificacao);
    }

    return value;
  }

}
